export const chains: { name: string; ids: number[] }[] = [
  {
    name: 'blast',
    ids: [81457, 168587773],
  },
  {
    name: 'base',
    ids: [8453, 84532],
  },
  { name: 'bsc', ids: [56, 91] },
  { name: 'matic', ids: [137, 80001] },
  { name: 'avax', ids: [99992, 8888888] },
  { name: 'ethereum', ids: [1, 4] },
  { name: 'solana', ids: [999999, 8888888] },
]
